import { FC } from "react";
import { ILicenseLink } from "../../../components/LicenseOptions/types";

const LicenseOptions: FC<ILicenseLink> = () => null;

export { LicenseOptions };
